export function reportError(error: string | Error, customAttributes?: Record<string, newrelic.SimpleType>): void {
  if (import.meta.env.NODE_ENV !== 'production') return;
  window.newrelic?.noticeError(error, customAttributes);
}
